<template>
  <Fragment>
    <px-finalizacao-print-pdf-btn
      v-if="!isPendenteFornecedor"
      :compra-id="compraId"
      :compra="compra"/>
    <px-finalizacao-print-pdf-dialog
      v-if="isPendenteFornecedor"
      :compra-id="compraId"
      :compra="compra"/>
  </Fragment>
</template>

<script>
import FinalizacaoPrintPdfBtn from '@/modules/finalizacao/FinalizacaoPrintPdfBtn.vue';
import FinalizacaoPrintPdfDialog from '@/modules/finalizacao/FinalizacaoPrintPdfDialog.vue';
import { SituacaoCompra } from 'px-business-components';
import { Fragment } from 'vue-frag';

export default {
  props: {
    compraId: String,
    compra: Object,
  },
  computed: {
    isPendenteFornecedor() {
      return this.compra.situacao === SituacaoCompra.keys.PENDENTE_FORNECEDOR.key;
    },
  },
  components: {
    pxFinalizacaoPrintPdfDialog: FinalizacaoPrintPdfDialog,
    pxFinalizacaoPrintPdfBtn: FinalizacaoPrintPdfBtn,
    Fragment,
  },
};
</script>
